import moment from 'moment'
import { membershipRequestService } from '../../../services/MembershipRequest'
import {
  IMembership,
  IMembershipObject,
  IMembershipRiderObject,
  IProgramServiceMembership,
  ITemporary
} from '../../../types'
import {
  MEMBERSHIP_FAIL,
  MEMBERSHIP_LIST_FAILURE,
  MEMBERSHIP_LIST_REQUEST,
  MEMBERSHIP_LIST_SUCCESS,
  MEMBERSHIP_REQUEST,
  MEMBERSHIP_SUCCESS,
  MEMBERSHIPSUCCES_UPDATE_STATUS,
  MEMBERSHIPSUCCES_UPDATING_STATUS,
  SET_SELECTED_MEMBERSHIP,
  TOGGLE_MEMBERSHIP_MODAL
} from '../../constants/'
import { actionCreators as organizationActionCreators } from '../organizations/index'
import { actionCreators as productActionCreators } from '../provider-products/index'
import { actionCreators as riderActionCreators } from '../riders/index'
import { actionCreators as serviceActionCreators } from '../services/index'

export interface IMembershipListRequest {
  type: MEMBERSHIP_LIST_REQUEST
}

export interface IMembershipListSuccess {
  type: MEMBERSHIP_LIST_SUCCESS
  membershipList: { [key: string]: IMembershipObject }
}

export interface IMembershipListFailure {
  type: MEMBERSHIP_LIST_FAILURE
  error: string
}

export interface IMembershipRequest {
  type: string
}

export interface IMembershipSuccess {
  type: string
  data: IProgramServiceMembership[]
}

export interface IMembershipFail {
  type: string
  error: string
}

export interface IMembershipRequestEligibility {
  type: string
  data: string | ITemporary
}

export interface IMembershipModal {
  type: string
}

export interface ISetActiveMembership {
  type: string
  selectedMembership: IMembership
}

export function membershipListRequest(): IMembershipListRequest {
  return {
    type: MEMBERSHIP_LIST_REQUEST
  }
}

export function membershipListSuccess(membershipList: { [key: string]: IMembershipObject }): IMembershipListSuccess {
  return {
    type: MEMBERSHIP_LIST_SUCCESS,
    membershipList
  }
}

export function membershipListFail(error: string): IMembershipListFailure {
  return {
    type: MEMBERSHIP_LIST_FAILURE,
    error
  }
}

export function MembershipUpdateStatus(data: ITemporary | string): any {
  return (dispatch: any) => {
    dispatch(MembershipUpdating())
    membershipRequestService
      .updateMembershipStatus(data)
      .then(
        (data: IMembership[]) => dispatch(MembershipSuccessUpdate(data)),
        (error: string) => dispatch(MembershipFail(error))
      )
  }
}

export function MembershipUpdating() {
  return {
    type: MEMBERSHIPSUCCES_UPDATING_STATUS
  }
}

export function MembershipSuccessUpdate(data: IMembership[]) {
  return {
    type: MEMBERSHIPSUCCES_UPDATE_STATUS,
    data
  }
}

export function MembershipRequest(): IMembershipRequest {
  return {
    type: MEMBERSHIP_REQUEST
  }
}

export function MembershipSuccess(data: IProgramServiceMembership[]): IMembershipSuccess {
  return {
    type: MEMBERSHIP_SUCCESS,
    data
  }
}

export function MembershipFail(error: string): IMembershipFail {
  return {
    type: MEMBERSHIP_FAIL,
    error
  }
}

export type IMembershipAction =
  | IMembershipListRequest
  | IMembershipListSuccess
  | IMembershipListFailure
  | IMembershipRequest
  | IMembershipSuccess
  | IMembershipFail
  | IMembershipRequestEligibility
  | IMembershipModal
  | ISetActiveMembership

export function getMembershipNewRequests(organizationId: string, page?: number) {
  return (dispatch: any) => {
    dispatch(MembershipRequest())
    membershipRequestService
      .fetchMembershipNewRequests(organizationId, page)
      .then(
        (data: IProgramServiceMembership[]) => dispatch(MembershipSuccess(data)),
        (error: string) => dispatch(MembershipFail(error))
      )
  }
}

export function getMembershipProcessedRequests(organizationId: string) {
  return (dispatch: any) => {
    dispatch(MembershipRequest())
    membershipRequestService
      .fetchMembershipProcessedRequests(organizationId)
      .then(
        (data: IProgramServiceMembership[]) => dispatch(MembershipSuccess(data)),
        (error: string) => dispatch(MembershipFail(error))
      )
  }
}

export function switchModal(): IMembershipModal {
  return {
    type: TOGGLE_MEMBERSHIP_MODAL
  }
}

export function setActiveMembership(selectedMembership: any): ISetActiveMembership {
  return {
    type: SET_SELECTED_MEMBERSHIP,
    selectedMembership
  }
}

export const getMembershipListByRiderIdAndOrgId = (riderId: string, orgId: string) => (dispatch: any) => {
  dispatch(riderActionCreators.ridersMembershipListRequest())
  dispatch(membershipListRequest())
  dispatch(organizationActionCreators.organizationListRequest())
  dispatch(productActionCreators.productListRequest())
  return membershipRequestService.getMembershipListByRiderIdAndOrgId(riderId, orgId).then(
    (membershipList: any) => {
      const mappedRiderMembership: IMembershipObject[] = membershipList.map((m: IMembershipRiderObject) => ({
        id: m.id,
        externalRiderId: m.externalRiderId,
        isLimitedByDate: !!m.beginsAt && !!m.expiresAt,
        isLimitedByRecurringMonths: !!m.recurringType,
        isLimitedByNumberOfRides: !!m.ridesNum && !!m.ridesRangeType,
        isSuspended: false,
        service: m.service,
        serviceId: m.service.id,
        beginsAt: m.beginsAt && moment(m.beginsAt),
        expiresAt: m.expiresAt && moment(m.expiresAt),
        requestedAt: m.requestedAt,
        recurringMonths: m.recurringType && m.recurringType.split(','),
        ridesNum: m.ridesNum,
        ridesRangeType: m.ridesRangeType,
        suspensionUntil: moment(),
        type: m.type,
        notAllowedPCA: m.notAllowedPCA || false
      }))
      const mappedMemberList: { [key: string]: IMembershipObject } = {}
      mappedRiderMembership.forEach(m => {
        if (m.id) {
          mappedMemberList[m.id] = m
        }
      })
      dispatch(riderActionCreators.ridersMembershipListSuccess(riderId, mappedRiderMembership))
      dispatch(membershipListSuccess(mappedMemberList))
    },
    (error: string) => {
      dispatch(riderActionCreators.ridersMembershipListFailure(error))
      dispatch(membershipListFail(error))
      dispatch(organizationActionCreators.organizationListFail(error))
      dispatch(productActionCreators.productListFail(error))
    }
  )
}



// WEBPACK FOOTER //
// ./src/state/actions/membership_request/index.ts